export default "__VITE_ASSET__B0XumJ1d__"